import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { UsersService } from 'app/shared/services/users.service';
import { Subject, take, takeUntil } from 'rxjs';
import { IUser } from 'app/shared/models/users.model';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { HelperService } from 'app/shared/services/helper.service';
import { SelectFormEnum } from 'app/shared/enums/select-form.enum';

@Component({
  selector: 'app-problem-record-owner-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SelectFormFieldComponent,
    TranslateModule
  ],
  templateUrl: './problem-record-owner-form.component.html',
  styleUrl: './problem-record-owner-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})

export class ProblemRecordOwnerFormComponent {
  form: any;
  viewMode = true;
  ownerUsers: IUser[] = [];
  @Input() problemRecordObject!: any;
  @Output() onTicketOwnerChange = new EventEmitter<IUser>();
  private destroy$ = new Subject<void>();
  

  constructor(
    public mainForm: FormGroupDirective,
    private usersService: UsersService,
    private helperService: HelperService
  ) { }

  ngOnChanges() {
    if (this.problemRecordObject) {
      this.getUsers();
    }
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('owner', new FormControl(''));
    this.form.addControl('ownerId', new FormControl(null));
  }

  getUsers() {
    this.usersService.users$.subscribe((users: IUser[]) => {
      this.ownerUsers = this.helperService.getUsersListWithSelectedUser(users, this.problemRecordObject.ownerId, this.problemRecordObject.owner);
    });
  }

  searchUsers(event: string, term: string, usersList: string, page: number = 0, take: number): void {
    this.usersService.getUsers(term, page * take, take)
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: IUser[]) => {
        if (event === SelectFormEnum.SCROLL) {
          (this as any)[usersList] = [...(this as any)[usersList], ...users];
        } else if (event === SelectFormEnum.SEARCH) {
          (this as any)[usersList] = [...users];
        }
      });
   }

    changeTicketOwner($event: IUser) {
      this.onTicketOwnerChange.emit($event);
  }

}
